import { render } from "./calculator-component.vue?vue&type=template&id=a65fc1de&scoped=true"
import script from "./calculator-component.vue?vue&type=script&lang=js"
export * from "./calculator-component.vue?vue&type=script&lang=js"

import "./calculator-component.vue?vue&type=style&index=0&id=a65fc1de&scoped=true&lang=css"

import exportComponent from "/builds/bluemantis/origo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a65fc1de"]])

export default __exports__